<template>
  <div class="credits">      
    <h1 class="subtitled">What Happened Here</h1>
    <div class="subtitle">an audio tour of your home at the end of isolation</div>
    <p>
      Share your sculpture with us:<br /> <code>@strangebirdimm #whathappenedhere</code>
    </p>
    <p>
      What more Strange Bird? Visit our <a href="/shop">merch page</a> for special items and donations, or
      sign up for <a href="/special/join/">our mailing list</a> to learn more about future productions.
    </p>
    <p>The stories you heard were all true.</p>
  
  <div class="sectionheader team">
    <img class="" :src="require('@/assets/credits/Home.jpg')" />
    <div class="title">CREDITS</div>
  </div>

  <div class="credit top">
    <div class="role">Created by</div>
    <div class="name">Strange Bird Immersive</div>
  </div>

  <div class="credit">
    <div class="role">Written and Arranged by</div>
    <div class="name">Haley E. R. Cooper</div>
  </div>

  <div class="credit">
    <div class="role">Creative Production and Web Design by</div>
    <div class="name">J. Cameron Cooper</div>
  </div>

  <div class="credit">
    <div class="role">Narrated by</div>
    <div class="name">Haley E. R. Cooper</div>
  </div>
  
  <div class="credit">
    <div class="role">Publicity Model</div>
    <div class="name">Lexie Jackson</div>
  </div>
  
  <div class="credit">
    <div class="role">Publicity</div>
    <div class="name">Bradley Winkler</div>
  </div>

  <div class="sectionheader kitchen">
    <img class="" :src="require('@/assets/credits/Kitchen.jpg')" />
    <div class="title">KITCHEN</div>
  </div>

  <div class="credit">
    <div class="title">"Cheese Fairy"</div>
    <div class="name">J. Cameron Cooper</div>
  </div>

  <div class="credit">
    <div class="title">"Cooking for Less"</div>
    <div class="name">Marlee Delia</div>
  </div>

  <div class="credit">
    <div class="title">"Pumpkin Pie"</div>
    <div class="name">Mary Agnes Williams</div>
  </div>


  <div class="sectionheader livingroom">
    <img class="" :src="require('@/assets/credits/LivingRoom.jpg')" />
    <div class="title">LIVING ROOM</div>
  </div>

  <div class="credit">
    <div class="title">"Ode to the Television"</div>
    <div class="name">Bradley Winkler</div>
  </div>

  <div class="credit">
    <div class="title">"Floorboards"</div>
    <div class="name">Katy Mulvaney</div>
  </div>


  <div class="sectionheader office">
    <img class="" :src="require('@/assets/credits/Office.jpg')" />
    <div class="title">OFFICE</div>
  </div>
  
  <div class="credit">
    <div class="title">"Zoom Interview"</div>
    <div class="name">Katie Richardson</div>
  </div>

  <div class="credit">
    <div class="title">"Meow Meow Meow"</div>
    <div class="name">Haley Eakin</div>
  </div>


  <div class="sectionheader bathroom">
    <img class="" :src="require('@/assets/credits/Bathroom.jpg')" />
    <div class="title">BATHROOM</div>
  </div>

  <div class="credit">
    <div class="title">"I Started Taking Baths"</div>
    <div class="name">Nick Rheinwald-Jones</div>
  </div>

  <div class="sectionheader bedroom">
    <img class="" :src="require('@/assets/credits/Bedroom.jpg')" />
    <div class="title">BEDROOM</div>
  </div>

  <div class="credit">
    <div class="title">"At-Home Massage"</div>
    <div class="name">Juliana Moreno Patel</div>
  </div>

  <div class="credit">
    <div class="title">"Sleeping on my Side"</div>
    <div class="name">Haley E. R. Cooper</div>
  </div>


  <div class="sectionheader score">
    <img class="" :src="require('@/assets/credits/Score.jpg')" />
    <div class="title">SCORE</div>
  </div>

  <div class="title">Welcome and Finale</div>
  <div class="credit">
    <div><span class="music">Bittersweet</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/3440-bittersweet">
        https://incompetech.filmmusic.io/song/3440-bittersweet</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="title">Kitchen</div>
  <div class="credit">
    <div><span class="music">I Knew a Guy</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/3895-i-knew-a-guy">
        https://incompetech.filmmusic.io/song/3895-i-knew-a-guy</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="credit">
    <div><span class="music">Mana Two Part 2</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/5713-mana-two-part-2">
        https://incompetech.filmmusic.io/song/5713-mana-two-part-2</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="credit">
    <div><span class="music">Night on the Docks - Piano</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/4131-night-on-the-docks---piano">
        https://incompetech.filmmusic.io/song/4131-night-on-the-docks---piano</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="title">Living Room</div>
  <div class="credit">
    <div><span class="music">Just As Soon</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/3947-just-as-soon">
        https://incompetech.filmmusic.io/song/3947-just-as-soon</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="credit">
    <div><span class="music">Cool Vibes</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/3553-cool-vibes">
        https://incompetech.filmmusic.io/song/3553-cool-vibes</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="title">Office</div>
  <div class="credit">
    <div><span class="music">On the Ground</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/4165-on-the-ground">
        https://incompetech.filmmusic.io/song/4165-on-the-ground</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="credit">
    <div><span class="music">Thinking Music</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/4522-thinking-music">
        https://incompetech.filmmusic.io/song/4522-thinking-music</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="credit">
    <div><span class="music">Stringed Disco</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/4427-stringed-disco">
        https://incompetech.filmmusic.io/song/4427-stringed-disco</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="title">Bathroom</div>
  <div class="credit">
    <div><span class="music">Wet Riffs</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/4618-wet-riffs">
        https://incompetech.filmmusic.io/song/4618-wet-riffs</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>

  <div class="title">Bedroom</div>
  <div class="credit">
    <div><span class="music">Fluidscape</span> by Kevin MacLeod</div>
    <div class="attribution">
      Link: <a href="https://incompetech.filmmusic.io/song/3767-fluidscape">
        https://incompetech.filmmusic.io/song/3767-fluidscape</a>
    </div>
    <div class="attribution">
      License: <a href="https://filmmusic.io/standard-license">
        https://filmmusic.io/standard-license</a>
    </div>
  </div>
  
  <div class="sectionheader thanks">
    <img class="" :src="require('@/assets/credits/Thanks.jpg')" />
    <!-- <div class="title">SPECIAL THANKS</div> -->
  </div>

  <h2>Special Thanks to...</h2>
    <ul class="thanks">
      <li>The Strange Bird Immersive fan club, the Conspiracy of Ravens</li>
      <li>The Everything Immersive Facebook Community</li>
      <li>Amy Garner Buchanan</li>
      <li>Marlee Delia</li>
      <li>Bryce Eakin</li>
      <li>Haley Eakin</li>
      <li>Tommy Honton</li>
      <li>Michelle </li>
      <li>Chris Moschella</li>
      <li>Amanda Marie Parker</li>
      <li>Juliana Moreno Patel</li>
      <li>Nick Rheinwald-Jones</li>
      <li>Katie Richardson</li>
      <li>Luke Voss</li>
      <li>Nathan Walton</li>
      <li>Mary Agnes Williams</li>
      <li>Bradley Winkler</li>
      <li>Lexie Jackson</li>
    </ul>
    
    <img class="logo" src="@/assets/logo.png" alt="Strange Bird Immersive" />

    <Player :sources="[require('@/assets/audio/Credits.mp3')]"
      :loop="true" :html5="true" :trackPostTime="0"
      ref="player" />
  </div>
</template>

<script>
import Player from '@/components/Player.vue';

export default {
  name: 'Credits',
  components: {
    Player,
  },
  mounted: function () {
    console.log('Credits mounted');
    this.delayplay();
  },
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
    delayplay() {
      console.log("Credits.delayplay");  
      this.$nextTick(() => {
        setTimeout(this.$refs.player.play, 2000);
        // setTimeout(this.$refs.player.setVolume, 2100, 0.25);
      })
    }
  }
}
</script>

<style scoped>
.credits {
}

.subtitled {
  padding-bottom: 0;
  margin-bottom: 0;
}
.subtitle {
  margin-top: 0;
  padding-top: 0;
  padding-bottom: 1rem;
  /* font-weight: bold; */
}

div.top {
  padding-top: 1.5rem;  
}

.sectionheader {
  position: relative;
  text-align: right;
  /* color: white; */
  width:100%;
  max-width: 500px;
  margin-top: 2rem;
  margin-bottom: 1rem;
  margin-left: auto;
  margin-right: auto;
}
.sectionheader img {
  width:100%;

}
.sectionheader .title {
  position: absolute;
  bottom: -0.68rem;
  right: 10px;
  margin-top: 0;
  margin-bottom: 0;
  font-size: 3rem;
  color: white;
  text-shadow:
		-1px -1px 0 #888,
		1px -1px 0 #888,
		-1px 1px 0 #888,
		1px 1px 0 #888;
}

.sectionheader .title .kitchen {
  top: 0;
  bottom: auto;
}

.credit {
  padding-top: 0.2rem;
  padding-bottom: 1.5rem;
}

.role {
  font-size: 8pt;
  font-weight: bold;
  font-variant: small-caps;
  padding-bottom: 0.2rem;
}
.title {
  font-variant: small-caps;
  font-weight: bold;
  font-size: 10pt;
}

.name {
  
}

.music {
  font-style: italic;
}

.attribution {
  font-size: small;
}

img.logo {
  width: 100%;
  max-width: 500px;
  position: relative; /* put on top of player controls */
  z-index: 10;
}

ul.thanks {
  padding-left: 1rem;
  padding-right: 1rem;
}
ul.thanks li {
  list-style-type: none;
  padding: 0.3rem;
}

/* player mods - deep for modifying Player child elt */
/deep/ .bottom-control {
  text-align: right;
  margin-bottom: 0.5rem;
}
/deep/ .bottom-control button.rewind,
/deep/ .bottom-control button.fastforward,
/deep/ .bottom-control .seek {
  display: none;
}
/deep/ .bottom-control button.pause,
/deep/ .bottom-control button.play {
  width: 10vh !important;
  height: 10vh !important;
}
/deep/ .bottom-control button.pause div.label,
/deep/ .bottom-control button.play div.label {
  font-size: smaller;
}

</style>
